// @flow
import * as React from 'react';
import _ from 'lodash';
import cn from 'classnames';

import type { AverageGradesOptions } from 'api';
import { Select } from 'client/components/common';
import * as css from './Filter.scss';

type Props = {
	study: string,
	cities: any,
	schools: any,
	studies: any,
	onChange: (options: AverageGradesOptions) => void,
};

const CITIES_MAX = 3;
const SCHOOLS_MAX = 2;

// const TEST_SCHOOL = 'עירוני ע"ש בליך';

const Filter = (props: Props) => {
	const [currentStudy, setCurrentStudy] = React.useState('');
	const [currentCities, setCurrentCities] = React.useState([]);
	const [currentSchools, setCurrentSchools] = React.useState([]);
	const citySelectDefaultLabel = 'יישוב';
	const citySelectDefaultLabel2 = 'הוספת יישוב';
	const studySelectDefaultLabel = 'מקצוע';
	const schoolSelectDefaultLabel = 'שם מוסד';
	const schoolSelectDefaultLabel2 = 'שם מוסד';
	const cities = _.reduce(
		props.cities,
		(acc, isEnabled, city) => {
			if (isEnabled) {
				acc.push(city);
			}

			return acc;
		},
		[]
	).sort((a, b) => a.localeCompare(b));
	const schools = _.reduce(
		props.schools,
		(acc, isEnabled, school) => {
			if (isEnabled) {
				acc.push(school);
			}

			return acc;
		},
		[]
	).sort((a, b) => a.localeCompare(b));

	const onStudyChange = React.useCallback((index: number, study: string) => {
		setCurrentStudy(study);
	}, []);

	const onCityChange = (index: number, city: string) => {
		setCurrentCities(prevCities => {
			const updatedCities = [...prevCities];

			if (index === -1) {
				// discard
				updatedCities.splice(updatedCities.indexOf(city), 1);
			} else {
				// add
				updatedCities[index] = city;
			}

			return updatedCities;
		});
	};

	const onSchoolChange = (index: number, school: string) => {
		setCurrentSchools(prevSchools => {
			const updatedSchools = [...prevSchools];

			if (index === -1) {
				// discard
				updatedSchools.splice(updatedSchools.indexOf(school), 1);
			} else {
				// add
				updatedSchools[index] = school;
			}

			return updatedSchools;
		});
	};

	React.useEffect(() => {
		if (currentStudy) {
			props.onChange({
				study: currentStudy,
				city: currentCities.filter(city => !!city),
				schools: currentSchools.filter(school => !!school),
			});
		}
	}, [currentStudy, currentCities, currentSchools]);

	return (
		<div className={css.filter}>
			<Select
				className={css.select}
				options={_.filter(props.studies, o => o !== props.study)}
				defaultOptionIndex={0}
				onChange={onStudyChange}
				defaultLabel={studySelectDefaultLabel}
				labelPostfix=" יח'"
			/>

			{_.map(Array.from({ length: CITIES_MAX }), (o, index) => {
				const options = _.reduce(
					cities,
					(acc, city) => {
						const cityIndex = currentCities.indexOf(city);
						const isCitySelectedByOtherInputs = cityIndex >= 0;

						if (!isCitySelectedByOtherInputs) {
							acc.push(city);
						}

						return acc;
					},
					[]
				);

				return (
					<Select
						className={css.select}
						index={index}
						options={options}
						onChange={onCityChange}
						defaultLabel={index === 0 ? citySelectDefaultLabel : citySelectDefaultLabel2}
						isActive={index === 0 || !!currentCities[index]}
						key={`city-${index}`}
						clearable
					/>
				);
			})}

			{_.map(Array.from({ length: SCHOOLS_MAX }), (o, index) => {
				const options = _.reduce(
					schools,
					(acc, school) => {
						const schoolIndex = currentSchools.indexOf(school);
						const isSchoolSelectedByOtherInputs = schoolIndex >= 0;

						if (!isSchoolSelectedByOtherInputs) {
							acc.push(school);
						}

						return acc;
					},
					[]
				);

				return (
					<Select
						className={cn(css.select, css.school)}
						index={index}
						options={options}
						onChange={onSchoolChange}
						defaultLabel={index === 0 ? schoolSelectDefaultLabel : schoolSelectDefaultLabel2}
						isActive={index === 0 || !!currentSchools[index]}
						key={`school-${index}`}
						clearable
					/>
				);
			})}
		</div>
	);
};

export default Filter;
